import { isArrayLike, defaultOf, equalArrays, compareArrays, comparePrimitives, int32ToString, uncurry4, numberHash, compare, equals } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Fertilizer_$reflection, FertilizerModule_Opt_speed, FertilizerModule_Opt_quality, FertilizerModule_Opt_name } from "./Model/Skills.js";
import { zip, unzip, equalsWith, sortBy, setItem, sortInPlaceBy, fill, initialize, mapIndexed2, partition, mapIndexed, concat as concat_1, map2, append, item, fold, choose, minBy, map } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { Array_groupBy } from "./fable_modules/fable-library-js.4.29.0/Seq2.js";
import { toString, Record, Union } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { Date$, DateModule_totalDays, DateModule_daySpan, FarmCropModule_growsInSeason, CropModule_growsInSeason, CropModule_regrows, Growth_daysNeededFor, Growth_maxHarvests, Crop, Date$_$reflection, FarmCrop_$reflection, Crop_$reflection } from "./Model/Crops.js";
import { bool_type, record_type, array_type, tuple_type, option_type, int32_type, union_type, uint32_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { Location, Game_growthTime } from "./Model/Game.js";
import { Selected_inSeasonCrops, Selected_fertilizersOpt, fertilizerCostOpt, Optimizer_regrowCropProfitData, Optimizer_nonRegrowCropProfitPerHarvest, Optimizer_regrowCropXpData, Optimizer_nonRegrowCropXpPerHarvest, replacedFertilizerPerHarvest } from "./Query.js";
import { map as map_2, choose as choose_1, concat, singleton, collect, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { rangeDouble } from "./fable_modules/fable-library-js.4.29.0/Range.js";
import { min, max } from "./fable_modules/fable-library-js.4.29.0/Double.js";
import { map as map_1, value as value_3 } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { equalTo, lessEq } from "yalps";
import { ofArray, toArray, singleton as singleton_1, empty, ofArrayWithTail, cons } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { SeasonModule_span } from "./Model/Crops.js";
import { Util_maxBy } from "./Types.js";

function fertilizerStrictlyWorse(fert1, cost1, fert2, cost2) {
    if ((!equals(FertilizerModule_Opt_name(fert1), FertilizerModule_Opt_name(fert2)) && (compare(cost1, cost2) >= 0)) && (FertilizerModule_Opt_quality(fert1) <= FertilizerModule_Opt_quality(fert2))) {
        return FertilizerModule_Opt_speed(fert1) <= FertilizerModule_Opt_speed(fert2);
    }
    else {
        return false;
    }
}

function removeStrictlyWorseFertilizers(fertilizersAndCost) {
    return fertilizersAndCost.filter((fertCost) => !fertilizersAndCost.some((tupledArg) => fertilizerStrictlyWorse(fertCost[0], fertCost[1], tupledArg[0], tupledArg[1])));
}

function groupFertilizersBySpeed(fertilizersAndCost) {
    return map((tupledArg) => [minBy((tuple_1) => tuple_1[1], tupledArg[1], {
        Compare: compare,
    })[0], 0], Array_groupBy((arg) => FertilizerModule_Opt_speed(arg[0]), fertilizersAndCost, {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }));
}

class Variable extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DayUsedForBridgeCrop", "DayUsedForRegrowCrop", "PlantCrop", "PlantBridgeCrop", "PlantCropUnreplacedFertilizer", "PlantRegrowCropFixedHarvests", "PlantRegrowCropFirstHarvests", "PlantRegrowCropRegrowHarvests"];
    }
}

function Variable_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Optimizer.Variable", [], Variable, () => [[], [], [["Item", Crop_$reflection()]], [["Item", Crop_$reflection()]], [["Item", Crop_$reflection()]], [["Item1", FarmCrop_$reflection()], ["Item2", uint32_type]], [["Item1", FarmCrop_$reflection()], ["Item2", uint32_type]], [["Item", FarmCrop_$reflection()]]]);
}

class FertilizerSpanRequest extends Record {
    constructor(Start, Stop, Fertilizer, FertilizerCost, Variables) {
        super();
        this.Start = (Start | 0);
        this.Stop = (Stop | 0);
        this.Fertilizer = Fertilizer;
        this.FertilizerCost = FertilizerCost;
        this.Variables = Variables;
    }
}

function FertilizerSpanRequest_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Optimizer.FertilizerSpanRequest", [], FertilizerSpanRequest, () => [["Start", int32_type], ["Stop", int32_type], ["Fertilizer", option_type(Fertilizer_$reflection())], ["FertilizerCost", uint32_type], ["Variables", array_type(tuple_type(int32_type, Variable_$reflection()))]]);
}

export class FertilizerDateSpan extends Record {
    constructor(StartDate, EndDate, Fertilizer, CropHarvests, RegrowCrop) {
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Fertilizer = Fertilizer;
        this.CropHarvests = CropHarvests;
        this.RegrowCrop = RegrowCrop;
    }
}

export function FertilizerDateSpan_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Optimizer.FertilizerDateSpan", [], FertilizerDateSpan, () => [["StartDate", Date$_$reflection()], ["EndDate", Date$_$reflection()], ["Fertilizer", option_type(Fertilizer_$reflection())], ["CropHarvests", array_type(tuple_type(Crop_$reflection(), uint32_type, bool_type))], ["RegrowCrop", option_type(tuple_type(int32_type, FarmCrop_$reflection(), uint32_type))]]);
}

function bridgeCropVariables(settings, objectiveValue, season, fertilizer, fertCost, prevSeasonCrops) {
    return map((tupledArg) => {
        const crop = tupledArg[0];
        return [[season, new Variable(3, [crop])], [["Objective", objectiveValue(crop, tupledArg[1], fertilizer, fertCost)], ["BridgeDays@" + toString(season), Game_growthTime(settings.Game, fertilizer, crop)], ["BridgeHarvests@" + toString(season), 1]]];
    }, prevSeasonCrops);
}

function regularCropVariables(settings, objectiveValue, season, fertilizer, fertCost, crops) {
    return choose((tupledArg) => {
        const crop = tupledArg[0];
        const value = objectiveValue(crop, tupledArg[1], fertilizer, fertCost);
        if (value < 0) {
            return undefined;
        }
        else {
            return [[season, new Variable(2, [crop])], [["Objective", value], [toString(season), Game_growthTime(settings.Game, fertilizer, crop)]]];
        }
    }, crops);
}

function unreplacedFertilizerVariables(settings, season, fertilizer, fertCost, crops) {
    return choose((tupledArg) => {
        const crop = tupledArg[0];
        if ((fertCost === 0) ? true : (replacedFertilizerPerHarvest(settings, crop) === 0)) {
            return undefined;
        }
        else {
            const profit_1 = tupledArg[1](fertilizer);
            if (profit_1 < 0) {
                return undefined;
            }
            else {
                return [[season, new Variable(4, [crop])], [["Objective", profit_1], [toString(season), Game_growthTime(settings.Game, fertilizer, crop)], ["EndingCrop", 1]]];
            }
        }
    }, crops);
}

function regrowVariablesAndConstraints(settings, season, prevDays, totalDays, fertIndex, fertilizer, regrowValues, constraints, regrowCrops) {
    if (regrowCrops.length === 0) {
        return [constraints, []];
    }
    else {
        const patternInput = fold((tupledArg, tupledArg_1) => {
            const constraints_1 = tupledArg[0];
            const variables = tupledArg[1];
            const crop = tupledArg_1[0];
            const data_1 = item(fertIndex, tupledArg_1[1]);
            const growthTime = Game_growthTime(settings.Game, fertilizer, new Crop(0, [crop]));
            const minHarvests = Growth_maxHarvests(crop.RegrowTime, growthTime, prevDays);
            const maxHarvests = Growth_maxHarvests(crop.RegrowTime, growthTime, totalDays);
            const fixedVariables = toList(delay(() => collect((h) => {
                const cost = data_1.Cost(h);
                const usedDays = Growth_daysNeededFor(crop.RegrowTime, growthTime, h);
                return singleton([[season, new Variable(5, [crop, h])], append([["Objective", (data_1.ProfitPerHarvest * h) - cost], [toString(season), (prevDays > usedDays) ? 0 : (usedDays - prevDays)]], regrowValues)]);
            }, rangeDouble(max(minHarvests, 1), 1, min(maxHarvests, data_1.HarvestsForMinCost - 1)))));
            if (maxHarvests >= data_1.HarvestsForMinCost) {
                const harvests = max(data_1.HarvestsForMinCost, minHarvests);
                const usedDays_1 = Growth_daysNeededFor(crop.RegrowTime, growthTime, harvests);
                const harvestsName = (crop.Seed.toString() + "@") + toString(season);
                const firstVariable = [[season, new Variable(6, [crop, harvests])], append([["Objective", (data_1.ProfitPerHarvest * harvests) - data_1.MinCost], ["RegrowDays@" + toString(season), ~~usedDays_1 - ~~prevDays], [harvestsName, -(maxHarvests - harvests)]], regrowValues)];
                const regrowVariable = [[season, new Variable(7, [crop])], [["Objective", data_1.ProfitPerHarvest], [harvestsName, 1], ["RegrowDays@" + toString(season), value_3(crop.RegrowTime)]]];
                return [cons([harvestsName, lessEq(0)], constraints_1), cons(ofArrayWithTail([firstVariable, regrowVariable], fixedVariables), variables)];
            }
            else {
                return [constraints_1, cons(fixedVariables, variables)];
            }
        }, [constraints, empty()], regrowCrops);
        const regrowDayVariable = [[season, new Variable(1, [])], [[toString(season), 1], ["RegrowDays@" + toString(season), -1]]];
        return [cons(["RegrowDays@" + toString(season), equalTo(0)], patternInput[0]), Array.from(concat(cons(singleton_1(regrowDayVariable), patternInput[1])))];
    }
}

function bridgeToNextSeason(settings, objectiveValue, season, nextSeason, days, bridgeCropsVars, fertilizerData, constraintsAndVariables) {
    return map2((tupledArg, tupledArg_1) => {
        const variables = tupledArg[1];
        return [ofArrayWithTail([[toString(nextSeason), lessEq(days - 1)], ["BridgeDays@" + toString(nextSeason), equalTo(1)], ["BridgeHarvests@" + toString(nextSeason), equalTo(1)]], tupledArg[0]), (bridgeCropsVars.length === 0) ? variables : ofArrayWithTail([[[[season, new Variable(0, [])], [[toString(season), 1], ["BridgeDays@" + toString(nextSeason), -1]]], [[nextSeason, new Variable(0, [])], [[toString(nextSeason), 1], ["BridgeDays@" + toString(nextSeason), -1]]]], bridgeCropVariables(settings, objectiveValue, nextSeason, tupledArg_1[0], tupledArg_1[1], bridgeCropsVars)], variables)];
    }, constraintsAndVariables, fertilizerData);
}

function bridgeRegrowToNextSeason(season, days, nextSeason, regrowValues) {
    return append([["BridgeDays@" + toString(nextSeason), 1], ["BridgeHarvests@" + toString(nextSeason), 1], [toString(season), days - 1]], regrowValues);
}

function createModels(startSeason, endSeason, constraintsAndVariables, fertilizerData) {
    return map2((tupledArg, tupledArg_1) => {
        const variables_1 = concat_1(tupledArg[1]);
        return [new FertilizerSpanRequest(startSeason, endSeason, tupledArg_1[0], tupledArg_1[1], map((tuple) => tuple[0], variables_1)), {
            constraints: toArray(tupledArg[0]),
            direction: "maximize",
            integers: true,
            objective: "Objective",
            variables: mapIndexed((i, tupledArg_2) => [i, tupledArg_2[1]], variables_1),
        }];
    }, constraintsAndVariables, fertilizerData);
}

function fertilizerAndCropData(data, settings, objective, seasons) {
    let f1, f1_1;
    const patternInput = (objective.tag === 1) ? [groupFertilizersBySpeed, (_arg) => ((data_2) => ((fertilizer_1) => ((_arg_1) => data_2(fertilizer_1)))), (f1 = Optimizer_nonRegrowCropXpPerHarvest(data)(settings), (arg) => map_1((x) => ((arg10$0040) => x), f1(arg))), (f1_1 = Optimizer_regrowCropXpData(data)(settings), (arg_1) => map_1((x_2) => ((arg10$0040_1) => x_2), f1_1(arg_1)))] : [removeStrictlyWorseFertilizers, (crop) => ((data_1) => ((fertilizer) => ((fertCost) => (data_1(fertilizer) - (replacedFertilizerPerHarvest(settings, crop) * fertCost))))), Optimizer_nonRegrowCropProfitPerHarvest(data)(settings), Optimizer_regrowCropProfitData(data)(settings)];
    const fertilizerData = patternInput[0](Array.from(choose_1((fertilizer_2) => map_1((cost) => [fertilizer_2, cost], fertilizerCostOpt(data, settings)(FertilizerModule_Opt_name(fertilizer_2))), Selected_fertilizersOpt(data, settings))));
    const patternInput_1 = partition(CropModule_regrows, Array.from(Selected_inSeasonCrops(data, settings)));
    const cropData = choose((crop_1) => map_1((objectiveValue_1) => [crop_1, objectiveValue_1], patternInput[2](crop_1)), patternInput_1[1]);
    const cropData_1 = equals(settings.Game.Location, new Location(0, [])) ? map((season) => cropData.filter((arg_2) => CropModule_growsInSeason(season, arg_2[0])), seasons) : [cropData];
    const regrowCropData_1 = choose((_arg_5) => {
        if (_arg_5.tag === 1) {
            return undefined;
        }
        else {
            const crop_2 = _arg_5.fields[0];
            return map_1((data_3) => [crop_2, map((arg_3) => data_3(arg_3[0]), fertilizerData)], patternInput[3](crop_2));
        }
    }, patternInput_1[0]);
    return [fertilizerData, cropData_1, equals(settings.Game.Location, new Location(0, [])) ? mapIndexed((i, season_1) => regrowCropData_1.filter((tupledArg) => {
        const crop_3 = tupledArg[0];
        if (FarmCropModule_growsInSeason(season_1, crop_3)) {
            if (i === (seasons.length - 1)) {
                return true;
            }
            else {
                return !FarmCropModule_growsInSeason(item(i + 1, seasons), crop_3);
            }
        }
        else {
            return false;
        }
    }), seasons) : [regrowCropData_1], patternInput[1]];
}

function createRequests(data, settings, objective) {
    const patternInput = equals(settings.Game.Location, new Location(0, [])) ? [SeasonModule_span(settings.Game.StartDate.Season, settings.Game.EndDate.Season), DateModule_daySpan(settings.Game.StartDate, settings.Game.EndDate)] : [new Int32Array([settings.Game.StartDate.Season]), new Uint32Array([DateModule_totalDays(settings.Game.StartDate, settings.Game.EndDate)])];
    const seasons = patternInput[0];
    const days = patternInput[1];
    const patternInput_1 = fertilizerAndCropData(data, settings, objective, seasons);
    const objectiveValue = patternInput_1[3];
    const fertilizerData = patternInput_1[0];
    const cropData = patternInput_1[1];
    const nextSeasonModels = (prevDays_mut, startSeason_mut, endSeason_mut, regrowCropVars_mut, regrowValues_mut, constraintsAndVariables_mut, models_mut) => {
        nextSeasonModels:
        while (true) {
            const prevDays = prevDays_mut, startSeason = startSeason_mut, endSeason = endSeason_mut, regrowCropVars = regrowCropVars_mut, regrowValues = regrowValues_mut, constraintsAndVariables = constraintsAndVariables_mut, models = models_mut;
            const totalDays = prevDays + item(startSeason, days);
            const regularCropVars = item(startSeason, cropData);
            const constraintsAndVariables_1 = mapIndexed2((fertIndex, tupledArg, tupledArg_1) => {
                const fert = tupledArg_1[0];
                const regularVars = regularCropVariables(settings, uncurry4(objectiveValue), startSeason, fert, tupledArg_1[1], regularCropVars);
                const patternInput_2 = regrowVariablesAndConstraints(settings, startSeason, prevDays, totalDays, fertIndex, fert, regrowValues, tupledArg[0], regrowCropVars);
                return [patternInput_2[0], ofArrayWithTail([regularVars, patternInput_2[1]], tupledArg[1])];
            }, constraintsAndVariables, fertilizerData);
            const models_1 = cons(createModels(startSeason, endSeason, constraintsAndVariables_1, fertilizerData), models);
            if (startSeason === 0) {
                return models_1;
            }
            else {
                const nextSeason = (startSeason - 1) | 0;
                let bridgeCropsVars;
                let predicate;
                let f2;
                const season = item(nextSeason, seasons) | 0;
                f2 = ((_arg) => CropModule_growsInSeason(season, _arg));
                predicate = ((arg) => f2(arg[0]));
                bridgeCropsVars = regularCropVars.filter(predicate);
                let regrowCropsVars;
                let predicate_1;
                let f2_1;
                const season_1 = item(nextSeason, seasons) | 0;
                f2_1 = ((crop) => FarmCropModule_growsInSeason(season_1, crop));
                predicate_1 = ((arg_1) => f2_1(arg_1[0]));
                regrowCropsVars = regrowCropVars.filter(predicate_1);
                if ((bridgeCropsVars.length + regrowCropsVars.length) === 0) {
                    return models_1;
                }
                else {
                    const constraintsAndVariables_2 = bridgeToNextSeason(settings, uncurry4(objectiveValue), startSeason, nextSeason, item(nextSeason, days), bridgeCropsVars, fertilizerData, constraintsAndVariables_1);
                    prevDays_mut = totalDays;
                    startSeason_mut = nextSeason;
                    endSeason_mut = endSeason;
                    regrowCropVars_mut = regrowCropsVars;
                    regrowValues_mut = bridgeRegrowToNextSeason(startSeason, item(startSeason, days), nextSeason, regrowValues);
                    constraintsAndVariables_mut = constraintsAndVariables_2;
                    models_mut = models_1;
                    continue nextSeasonModels;
                }
            }
            break;
        }
    };
    return concat_1(concat(initialize(seasons.length, (endSeason_1) => {
        const startingConstraints = ofArray([[int32ToString(endSeason_1), lessEq(item(endSeason_1, days) - 1)], ["EndingCrop", lessEq(1)]]);
        const constraintsAndVariables_3 = map((tupledArg_2) => [startingConstraints, singleton_1(unreplacedFertilizerVariables(settings, endSeason_1, tupledArg_2[0], tupledArg_2[1], item(endSeason_1, cropData)))], fertilizerData);
        return nextSeasonModels(0, endSeason_1, endSeason_1, item(endSeason_1, patternInput_1[2]), [["EndingCrop", 1]], constraintsAndVariables_3, empty());
    })));
}

function weightedIntervalSchedule(solvedRequests) {
    const bestDownTo = fill(new Array(solvedRequests.length + 1), 0, solvedRequests.length + 1, [empty(), 0]);
    sortInPlaceBy((tupledArg) => tupledArg[0].Start, solvedRequests, {
        Compare: comparePrimitives,
    });
    for (let i = solvedRequests.length - 1; i >= 0; i--) {
        const patternInput = item(i, solvedRequests);
        const solution = patternInput[1];
        const request_1 = patternInput[0];
        let j = i + 1;
        while ((j < solvedRequests.length) && (request_1.Stop >= item(j, solvedRequests)[0].Start)) {
            j = ((j + 1) | 0);
        }
        const patternInput_1 = item(j, bestDownTo);
        const value = (solution.result - request_1.FertilizerCost) + patternInput_1[1];
        setItem(bestDownTo, i, Util_maxBy((tuple) => tuple[1], item(i + 1, bestDownTo), [cons([request_1, solution], patternInput_1[0]), value]));
    }
    return item(0, bestDownTo);
}

function sortAndPartitionVariables(vars, request, solution) {
    return partition((arg_1) => {
        const _arg = arg_1[1][0];
        switch (_arg.tag) {
            case 5:
            case 6:
            case 7:
                return true;
            default:
                return false;
        }
    }, sortBy((tuple) => tuple[0], choose((tupledArg) => {
        const patternInput = item(tupledArg[0], request.Variables);
        const variable = patternInput[1];
        return map_1((tupledArg_1) => [[patternInput[0], tupledArg_1[1], Game_growthTime(vars, request.Fertilizer, tupledArg_1[0])], [variable, tupledArg[1] >>> 0]], (variable.tag === 0) ? undefined : ((variable.tag === 2) ? [variable.fields[0], 0] : ((variable.tag === 3) ? [variable.fields[0], 1] : ((variable.tag === 4) ? [variable.fields[0], 2] : ((variable.tag === 5) ? [new Crop(0, [variable.fields[0]]), 3] : ((variable.tag === 6) ? [new Crop(0, [variable.fields[0]]), 3] : ((variable.tag === 7) ? [new Crop(0, [variable.fields[0]]), 4] : undefined)))))));
    }, solution.variables), {
        Compare: compareArrays,
    }));
}

function toDateSpans(vars, solvedRequests, totalValue) {
    const seasons = SeasonModule_span(vars.StartDate.Season, vars.EndDate.Season);
    return [totalValue, Array.from(map_2((tupledArg) => {
        const request = tupledArg[0];
        const patternInput = sortAndPartitionVariables(vars, request, tupledArg[1]);
        const regrowVariables = patternInput[0];
        let regrowCrop;
        let matchResult, crop, harvests, n, season, crop_1, crop2, harvests_1, harvests2, n_1, season_1, season2, regrowVariables_1;
        if (!equalsWith(equalArrays, regrowVariables, defaultOf()) && (regrowVariables.length === 1)) {
            if (item(0, regrowVariables)[1][0].tag === 5) {
                matchResult = 0;
                crop = item(0, regrowVariables)[1][0].fields[0];
                harvests = item(0, regrowVariables)[1][0].fields[1];
                n = item(0, regrowVariables)[1][1];
                season = item(0, regrowVariables)[0][0];
            }
            else if (item(0, regrowVariables)[1][0].tag === 6) {
                matchResult = 0;
                crop = item(0, regrowVariables)[1][0].fields[0];
                harvests = item(0, regrowVariables)[1][0].fields[1];
                n = item(0, regrowVariables)[1][1];
                season = item(0, regrowVariables)[0][0];
            }
            else {
                matchResult = 2;
                regrowVariables_1 = regrowVariables;
            }
        }
        else if (!equalsWith(equalArrays, regrowVariables, defaultOf()) && (regrowVariables.length === 2)) {
            if (item(0, regrowVariables)[1][0].tag === 6) {
                if (item(1, regrowVariables)[1][0].tag === 7) {
                    matchResult = 1;
                    crop_1 = item(0, regrowVariables)[1][0].fields[0];
                    crop2 = item(1, regrowVariables)[1][0].fields[0];
                    harvests_1 = item(0, regrowVariables)[1][0].fields[1];
                    harvests2 = item(1, regrowVariables)[1][1];
                    n_1 = item(0, regrowVariables)[1][1];
                    season_1 = item(0, regrowVariables)[0][0];
                    season2 = item(1, regrowVariables)[0][0];
                }
                else {
                    matchResult = 2;
                    regrowVariables_1 = regrowVariables;
                }
            }
            else {
                matchResult = 2;
                regrowVariables_1 = regrowVariables;
            }
        }
        else {
            matchResult = 2;
            regrowVariables_1 = regrowVariables;
        }
        switch (matchResult) {
            case 0: {
                regrowCrop = [season - request.Start, crop, harvests];
                break;
            }
            case 1: {
                regrowCrop = [season_1 - request.Start, crop_1, harvests_1 + harvests2];
                break;
            }
            default: {
                regrowCrop = undefined;
            }
        }
        const cropHarvests = choose((arg) => {
            const _arg = arg[1];
            switch (_arg[0].tag) {
                case 2:
                    return [_arg[0].fields[0], _arg[1], false];
                case 3: {
                    return [_arg[0].fields[0], 1, true];
                }
                case 4: {
                    return [_arg[0].fields[0], 1, false];
                }
                default:
                    return undefined;
            }
        }, patternInput[1]);
        const patternInput_1 = equals(vars.Location, new Location(0, [])) ? [new Date$(item(request.Start, seasons), (request.Start === 0) ? vars.StartDate.Day : 1), new Date$(item(request.Stop, seasons), (request.Stop === (seasons.length - 1)) ? vars.EndDate.Day : 28)] : [vars.StartDate, vars.EndDate];
        return new FertilizerDateSpan(patternInput_1[0], patternInput_1[1], request.Fertilizer, cropHarvests, regrowCrop);
    }, solvedRequests))];
}

export function createWorker() {
    const worker = new Worker((new URL("Worker.js", import.meta.url)), {
        type: "module",
    });
    let inProgressRequest = undefined;
    let nextRequest = undefined;
    const postWorker = (data, settings, objective) => {
        const patternInput = unzip(createRequests(data, settings, objective));
        inProgressRequest = [settings, patternInput[0]];
        worker.postMessage(patternInput[1]);
    };
    return [(data_1) => ((settings_1) => ((objective_1) => {
        if (inProgressRequest == null) {
            postWorker(data_1, settings_1, objective_1);
        }
        else {
            nextRequest = [data_1, settings_1, objective_1];
        }
    })), (dispatch) => {
        worker.onmessage = ((e) => {
            let tupledArg_1, array_1;
            const matchValue = e.data;
            const inProgressRequest_1 = inProgressRequest;
            let matchResult, requests_1, settings_2, solutions;
            if (isArrayLike(matchValue)) {
                if (inProgressRequest_1 != null) {
                    matchResult = 0;
                    requests_1 = inProgressRequest_1[1];
                    settings_2 = inProgressRequest_1[0];
                    solutions = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    if (nextRequest == null) {
                        inProgressRequest = undefined;
                        dispatch((tupledArg_1 = weightedIntervalSchedule((array_1 = zip(requests_1, solutions), array_1.filter((tupledArg) => {
                            return tupledArg[1].status === "optimal";
                        }))), toDateSpans(settings_2.Game, tupledArg_1[0], tupledArg_1[1])));
                    }
                    else {
                        const settings_3 = nextRequest[1];
                        const objective_2 = nextRequest[2];
                        const data_2 = nextRequest[0];
                        nextRequest = undefined;
                        postWorker(data_2, settings_3, objective_2);
                    }
                    break;
                }
                case 1: {
                    break;
                }
            }
        });
    }];
}

//# sourceMappingURL=Optimizer.js.map
